import { render, staticRenderFns } from "./BsBox.vue?vue&type=template&id=e6e5d296&scoped=true&"
import script from "./BsBox.vue?vue&type=script&lang=js&"
export * from "./BsBox.vue?vue&type=script&lang=js&"
import style0 from "./BsBox.vue?vue&type=style&index=0&id=e6e5d296&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5d296",
  null
  
)

export default component.exports